import { render, staticRenderFns } from "./ProrateAllowanceModal.vue?vue&type=template&id=35f3699c"
import script from "./ProrateAllowanceModal.vue?vue&type=script&lang=js"
export * from "./ProrateAllowanceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports